import React, { useState, useEffect } from "react";
import MasterMFTable from "./MasterMFTable";
import MasterMFHeader from "./MasterMFHeader";
import useApiNew from "../../../utils/useApiNew";
import Breadcrumbs from "../../../components/ui/Breadcrumbs";
import { handleGetOneData } from "../../../utils/handleGetOneData";
import { actionPermissions } from "../../../components/authNavigation/AuthNavbar";

const mutualFundMasterApiURL = `${process.env.REACT_APP_API_URL}api/mutual-funds`;

const MasterMF = () => {
  const [renderKey, setRenderKey] = useState(0);
  const [filteredData, setFilteredData] = React.useState();
  const [dateFilters, setDateFilters] = useState();
  const [isFilter, setIsFilter] = useState();
  const [globalFilters, setGlobalFilters] = React.useState();

  // API CONFIG
  const headers = {
    Authorization: `Bearer ${
      sessionStorage.getItem("subscriberToken")
        ? sessionStorage.getItem("subscriberToken")
        : sessionStorage.getItem("token")
    }`,
    "Content-Type": "application/json",
  };

  let { data, loading } = useApiNew(
    mutualFundMasterApiURL,
    "GET",
    { headers },
    renderKey,
  );

  data = data?.map((item) => ({
    ...item,
    status: item.status ? "Active" : "Inactive",
  }));
  console.log("data:::::", data);

  //EDIT
  const handleGetOneScript = (id) => {
    return handleGetOneData(data, id);
  };

  // ADD
  const handleFilter = () => {
    let filterData = data;

    if (dateFilters) {
      if (dateFilters.scheme_name) {
        filterData = filterData?.filter(
          (item) => item?.scheme_name === dateFilters.scheme_name,
        );
      }
      if (dateFilters.amc_name) {
        filterData = filterData?.filter(
          (item) => item?.amc_name === dateFilters.amc_name,
        );
      }
      if (dateFilters.scheme_type) {
        filterData = filterData?.filter(
          (item) => item?.scheme_type === dateFilters.scheme_type,
        );
      }
      if (dateFilters.scheme_plan) {
        filterData = filterData?.filter(
          (item) => item?.scheme_plan === dateFilters.scheme_plan,
        );
      }
    }
    if (globalFilters) {
      const searchTerm = globalFilters.toLowerCase();

      filterData = filterData?.filter((item) => {
        const searchableFields = [
          item?.isin,
          item?.amc_scheme_code,
          item?.scheme_code,
          item?.scheme_plan,
          item?.scheme_type,
          item?.rta_agent_code,
          item?.status,
        ];

        return searchableFields.some((field) =>
          field?.toLowerCase().includes(searchTerm),
        );
      });
    }
    setFilteredData(filterData);
  };

  useEffect(() => {
    handleFilter();
  }, [globalFilters, dateFilters]);

  console.log(data);
  const breadcrumbs = ["Home", "Master", "Mutual Fund"];

  const buttonConfig = {
    getOneHandler: handleGetOneScript,
  };

  return (
    <div className=" app-container min-h-[65vh] pb-[60px] pt-[100px]">
      <Breadcrumbs items={breadcrumbs} />
      <MasterMFHeader
        key={renderKey}
        onFilterChange={setDateFilters}
        tableData={data}
        setFilteredData={setFilteredData}
        setDateFilters={setDateFilters}
        setIsFilter={setIsFilter}
        isFilter={isFilter}
        isLoading={loading}
        setGlobalFilters={setGlobalFilters}
        globalFilter={globalFilters}
      />
      <MasterMFTable
        tableData={globalFilters || dateFilters ? filteredData : data}
        buttonConfig={buttonConfig}
        renderKey={renderKey}
        setGlobalFilters={setGlobalFilters}
        loading={loading}
        actionPermissions={actionPermissions("masters", "Mutual Fund")}
        setIsFilter={setIsFilter}
        isFilter={isFilter}
      />
    </div>
  );
};

export default MasterMF;
